import Vue from 'vue';

Vue.component('deep-link', () => import(/* webpackChunkName: "admin-deep-link" */ './DeepLink'));
